export default __webpack_public_path__ + "static/media/mpk_page.fed68ba8.png";